import { Component } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import {
  CropperPosition,
  Dimensions,
  ImageCroppedEvent,
  ImageTransform,
} from 'ngx-image-cropper';

declare var bootstrap: any;

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css'],
})
export class OrganizationComponent extends BaseCtl {
  imagePreview: string | ArrayBuffer | null = null;

  public maxFileSize = 512000;

  public errorMessage: string | null = null;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
    super('', locator, route);
    locator.config.getProperty('endpoint.org').then((property: string) => {
      this.initApiEndpoint(property);
    });
    let _self = this;
    locator.getPathVariable(route, function (params: any) {});
    _self.display();
  }

  /**
   * Populate Data into form
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.address = data.address;
    form.phone = data.phone;
    form.logoId = data.logoId;
  }

  /**
   * Display
   */
  public async display() {
    let _self = this;
    let url = _self.locator.config.get('endpoint.user') + '/organization';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.message;

      if (res.success) {
        _self.populateForm(_self.form.data, res.result.data);
      }
    });

    let url1 = _self.locator.config.get('endpoint.user') + '/uc';
    this.locator.http.get(url1, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
    });
  }

  /**
   * Show preview of the image
   * @param event
   */
  public async showPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result; 
      };
      // reader.readAsDataURL(file); 
    }
  }

  /**
   * Get the thumbnail of the image
   * @param logo
   * @returns
   */
  public async getDocThumbnailImage(logo: any) {
    return this.getDocThumbnail(logo);
  }

  /**
   * Get the thumbnail of the image
   * @param logo
   * @returns
   */
  public async getDocImage(logo: any) {
    return this.getDoc(logo);
  }

  /**
   * Preview the image
   */
  public async openPreviewModal(): Promise<void> {
    const modalElement = document.getElementById('imagePreviewModal');
    const modalInstance = new bootstrap.Modal(modalElement);
    modalInstance.show();
  }

  organizationDescription = false;
  organizationName = false;

  /**
   * Validation of the OrgName input
   */
  public async checkValueName(event: Event): Promise<void> {
    console.log('I am in check Value is method');
    const input = event.target as HTMLInputElement; // Cast event target as input element
    const value = this.normalizeSpaces(input.value.trim()); // Normalize spaces and trim leading/trailing spaces
    this.form.data['name'] = value === '' ? null : this.capitalizeWords(value);
    if (!this.form.data['name']) {
      console.log('In side error');
      this.form.data['name'] = undefined;
      this.form.inputerror['name'] = 'Name is Required';
      this.organizationName = true;
    } else {
      this.organizationName = false;
      this.form.inputerror['name'] = null;
    }
  }

  public async checkValueDescription(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement; 
    const value = this.normalizeSpaces(input.value.trim()); 
    
    this.form.data['address'] =
      value === '' ? null : this.capitalizeWords(value);
    if (!this.form.data['address']) {
      
      this.form.data['address'] = undefined;
      this.form.inputerror['address'] = 'Description is Required';
      this.organizationDescription = true;
    } else {
      this.organizationDescription = false;
      this.form.inputerror['address'] = null;
    }
  }

  /**
   * Normalize spaces in a string to ensure only one space between words.
   * @param str - Input string to normalize.
   * @returns Normalized string with single spaces.
   */
  normalizeSpaces(str: string): string {
    return str.replace(/\s+/g, ' '); // Replace multiple spaces with a single space
  }

  /**
   * Capitalize the first letter of each word in a string, allowing words with all uppercase characters.
   * @param str -
   * @returns
   */
  capitalizeWords(str: string): string {
    return str
      .split(' ') // Split the string by spaces
      .map(
        (word) =>
          word === word.toUpperCase() // Check if all characters are uppercase
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Otherwise, capitalize the first letter
      )
      .join(' '); 
  }

  // -------------------------------------Image Crop Function--------------------------
  showCropper = false;
  loading = false;
  croppedImage: SafeUrl = '';
  public imageId: any = 0;
  public imageCode: any;
  public imageName: any;
  public croppedImageFile: File | null = null;
  imageChangedEvent: Event | null = null;
  imageURL?: string;

  hidden = false;
  disabled = false;
  alignImage = 'center' as const;
  roundCropper = false;
  backgroundColor = 'grey';
  allowMoveImage = false;
  hideResizeSquares = false;
  canvasRotation = 0;
  aspectRatio = 4 / 3;
  containWithinAspectRatio = false;
  maintainAspectRatio = false;
  cropperStaticWidth = 0;
  cropperStaticHeight = 0;
  cropperMinWidth = 0;
  cropperMinHeight = 0;
  cropperMaxWidth = 0;
  cropperMaxHeight = 0;
  resetCropOnAspectRatioChange = true;
  cropper?: CropperPosition;
  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };

  fileChangeEvent(event: Event): void {
    this.loading = true;
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
      event.objectUrl || event.base64 || ''
    );
    const base64 = event.base64;
    if (!base64) return;
    // Convert Base64 to File
    const file = this.base64ToFile(base64, this.imageName);

    this.croppedImageFile = file;
  }

  imageLoaded() {
    this.showCropper = true;
    console.error('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.error('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }

  transformChange(transform: ImageTransform) {
    console.error('transform changed', transform);
  }

  rotateLeft() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }

  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! - 1,
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! + 1,
    };
  }

  moveDown() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! + 1,
    };
  }

  moveUp() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! - 1,
    };
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
      translateH: 0,
      translateV: 0,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  resetImage() {
    this.canvasRotation = 0;
    this.cropper = undefined;
    this.maintainAspectRatio = false;
    this.transform = {
      translateUnit: 'px',
      scale: 1,
      rotate: 0,
      flipH: false,
      flipV: false,
      translateH: 0,
      translateV: 0,
    };
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - 0.1,
    };
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + 0.1,
    };
  }

  updateRotation(rotate: number) {
    this.transform = {
      ...this.transform,
      rotate,
    };
  }

  toggleAspectRatio() {
    this.aspectRatio = this.aspectRatio === 4 / 3 ? 16 / 5 : 4 / 3;
  }

  toggleBackgroundColor() {
    this.backgroundColor = this.backgroundColor === 'red' ? 'blue' : 'red';
  }

  cancelCropping() {
    // Logic to cancel cropping and reset the cropper
    this.resetCropper();
  }

  resetCropper() {
    this.imageChangedEvent = null;
    this.showCropper = false;
    this.croppedImage = '';
    this.imageId = '';
    this.croppedImageFile = null;
  }

  private base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  public async saveCroppedImage() {
    if (!this.croppedImageFile) {
      alert('No cropped image available to save.');
      return;
    }
    await this.imageFormatter(this.croppedImageFile, 200, 200, 100);
    if (this.croppedImageFile) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;      
      };
      reader.readAsDataURL(this.croppedImageFile); // Convert the file to base64 URL
    }

    const code = this.imageCode;
    const imageId = 0;
    const url =
      this.locator.getEndpoint('endpoint.api.v1') +
      '/cuickdev/organization/doc/' +
      this.form.data['id'] +
      '/' +
      imageId +
      '/' +
      code;

    const param = {
      id: this.form.data.id,
    };

    this.locator.http.postMutipart(
      url,
      param,
      this.croppedImageFile,
      (res: any, error: any) => {
        if (error) {
          alert(error);
          return;
        }
        this.form.error = !res.success;
        this.form.message = res.result.message;
        if (res.success) {
          this.form['message'] = 'File is uploaded successfully.';
          this.form.data[code] = res.result.data[code];
          //this.form.data[code] = res.result.data.logoId;
          this.changeDoc();
          this.getDocThumbnail(this.form.data[code]);
          //this.getDoc(this.form.data[code]);
        }
      }
    );
    this.resetCropper();
  }

  fileError: boolean = false;
  imageSize:boolean=false;
  onFileChooseClicked(file:any) {
    console.log('User clicked the file input button');
    file = '';
       this.croppedImageFile=null;
    this.fileError=false;
    this.imageSize=false;
       this.croppedImageFile=null;
       this.imagePreview=null;
       this.imageChangedEvent = null;
       this.imageURL = '';
       this.croppedImage = '';
       this.showCropper = false;
       this.canvasRotation = 0;
       this.transform = {
      translateUnit: 'px',
      scale: 1,
      rotate: 0,
      flipH: false,
      flipV: false,
      translateH: 0,
      translateV: 0,
    };
  }

  public onFileChanged(event: any, code: string, imageId: any) {

    const file = event.target.files[0]; 
    if (file) {
      const allowedTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
      ];
      if (!allowedTypes.includes(file.type)) {
        this.fileError = true;
        return;
      }
    }
      const maxSize = 1 * 1024 * 1024; 
      if (file.size > maxSize) {
            this.imageSize=true;
          return;
      }

    this.fileChangeEvent(event);
    const fileObj = event.target.files[0];
      if (imageId === null || imageId === undefined) {
        imageId = 0;
      }
      this.imageName = fileObj['name'];
      this.imageId = imageId;
      this.imageCode = code;
    }

  resetFileInput(fileInput: HTMLInputElement): void {
    fileInput.value = ''; // Reset the file input
    this.imageName = null; // Clear the file name
    this.imageSize=false;
  }

  imagePath: any;
  public async imageFormatter(
    file: File,
    width?: number,
    height?: number,
    filesizeKb?: number
  ): Promise<void> {
    const endurl =
      this.locator.getEndpoint('endpoint.api.v1') +
      '/cuickdev/user/imageFormat';

    const url = this.urlRewrite(endurl);
    const formData = new FormData();
    formData.append('image', file);
    if (width) formData.append('width', width.toString());
    if (height) formData.append('height', height.toString());
    if (filesizeKb) formData.append('filesize_kb', filesizeKb.toString());

    const client = this.locator.http.getClient();

    try {
      const data: any = await new Promise((resolve, reject) => {
        client.post(url, formData, { responseType: 'json' }).subscribe(
          (response: any) => resolve(response),
          (error: any) => reject(error)
        );
      });
      console.log('data ', data);

      if (data.result.data?.path) {
        this.imagePath = data.result.data?.path;
      } else {
        this.form['error'] = true;
        this.form['message'] = 'Unexpected response structure';
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      this.form['error'] = true;
      this.form['message'] = 'Error uploading image';
    }
  }
  urlRewrite(endpoint: string) {
    let _self = this;
    let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
    let sid = localStorage.getItem(keySuffix + 'sessionId');
    if (!sid) {
      sid = '0';
    }
    endpoint = endpoint + ';jsessionid=' + sid;
    return endpoint;
  }

  public removeLogo(): void {
  // Clear the preview
  this.imagePreview = null;
  // this.croppedImageFile = null;
  // this.imageChangedEvent = null;
  // this.imageURL = '';
  // this.croppedImage = '';
  // this.showCropper = false;
  // this.canvasRotation = 0;
  // this.transform = {
  //   translateUnit: 'px',
  //   scale: 1,
  //   rotate: 0,
  //   flipH: false,
  //   flipV: false,
  //   translateH: 0,
  //   translateV: 0,
  // };

  // Remove logoId from form
  this.form.data['logoId'] = 0;
    this.save();

}

}
